import {
    GET_STATS_BY_EVENT_ID, CLEAN_EVENT_STATS, LOADING_STATS,
    GET_PURCHASES_FOR_HISTORY, LOADING_PURCHASES_HISTORY,
    GET_CONSUMPTIONS_FOR_HISTORY, LOADING_CONSUMPTIONS_HISTORY,
    GET_CREDIT_MOVEMENTS, LOADING_CREDIT_MOVEMENTS, SET_CREDIT_FILTERS,
    GET_NUMBER_OF_DELIVERED_PHOTOS,
    GET_NUMBER_OF_INDEXES_FACES,
    GET_NUMBER_OF_PHOTOS,
    GET_NUMBER_OF_SELFIES,
    GET_NUMBER_OF_USERS_ACCESS_BY_CODE,
    GET_NUMBER_OF_USERS_WITH_MATCH,
    GET_NUMBER_OF_UNIQUES_SHARES_BY_EVENT,
    GET_NUMBER_OF_UNIQUES_VIEWS_BY_EVENT,
    GET_NUMBER_OF_GLOBAL_VIEWS_BY_EVENT,
    GET_PHOTOS_BY_USER,
    GET_ORDERS_AMOUNT,
    GET_NUMBER_OF_ORDERS,
    GET_NUMBER_OF_PACK_ORDERS,
    GET_TOTAL_AMOUNT_ORDERS,
    GET_TOTAL_AMOUNT_PACK_ORDERS,
    GET_SOLD_PHOTOS,
    GET_SOLD_PACKS_AMOUNT,
    SIGN_OUT
} from "../actions/type";

const initialState = {
    numberOfPhotos: undefined,
    numberOfIndexedFaces: undefined,
    numberOfUsersAccessByCode: undefined,
    numberOfUsersWithMatch: undefined,
    numberOfDeliveredPhotos: undefined,
    numberOfSelfies: undefined,
    numberOfUniquesSharesByEvent: undefined,
    numberOfUniquesViewsByEvent: undefined,
    numberOfGlobalViewsByEvent: undefined,
    ordersAmount: undefined,
    numberOfOrders: undefined,
    numberOfPackOrders: undefined,
    totalAmountOrders: undefined,
    totalAmountPackOrders: undefined,
    soldPhotos: undefined,
    soldPacksAmount: undefined,
    photosByUser: undefined,
    
    // Estados de loading
    loading: false,
    
    // Estados unificados para compras (rawData se procesa en componente)
    purchasesData: undefined,
    loadingPurchases: false,
    
    // Estados unificados para consumos (rawData se procesa en componente) 
    consumptionsData: undefined,
    loadingConsumptions: false,

    creditMovements: undefined,
    loadingCreditMovements: false,
    // Sin rango elegido, cada pestaña aplica el suyo (accountCredit.js): Compras «Todo»,
    // Consumos «Últimos 30 días», que con «Todo» lee el histórico entero de accesos.
    creditFilters: { rangeKey: undefined, eventId: undefined },
};

const statsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_STATS_BY_EVENT_ID:
            return {
                ...state,
                numberOfPhotos: payload.Data.photos, //Fotos subidas en este evento
                numberOfIndexedFaces: payload.Data.indexedFaces, //Caras indexadas en todas las fotos
                numberOfUsersAccessByCode: payload.Data.users, //Usuarios únicos que han accedido
                numberOfUsersWithMatch: payload.Data.usersWithMatch, //Usuarios únicos que han encontrado fotos
                numberOfDeliveredPhotos: payload.Data.delivered, //Fotos únicas entregadas a usuario
                numberOfSelfies: payload.Data.selfies, //Selfies totales realizados
            };
        case GET_NUMBER_OF_DELIVERED_PHOTOS://Fotos únicas entregadas a usuario
            return {
                ...state,
                numberOfDeliveredPhotos: payload.Data,
            };
        case GET_NUMBER_OF_INDEXES_FACES://Caras indexadas en todas las fotos
            return {
                ...state,
                numberOfIndexedFaces: payload.Data,
            };
        case GET_NUMBER_OF_PHOTOS://Fotos subidas en este evento
            return {
                ...state,
                numberOfPhotos: payload.Data,
            };
        case GET_NUMBER_OF_SELFIES://Selfies totales realizados
            return {
                ...state,
                numberOfSelfies: payload.Data,
            };
        case GET_NUMBER_OF_USERS_ACCESS_BY_CODE://Usuarios únicos que han accedido
            return {
                ...state,
                numberOfUsersAccessByCode: payload.Data,
            };
        case GET_NUMBER_OF_USERS_WITH_MATCH://Usuarios únicos que han encontrado fotos
            return {
                ...state,
                numberOfUsersWithMatch: payload.Data,
            };
        case GET_NUMBER_OF_UNIQUES_SHARES_BY_EVENT:// Comparticiones unicas
            return {
                ...state,
                numberOfUniquesSharesByEvent: payload.Data,
            };
        case GET_NUMBER_OF_UNIQUES_VIEWS_BY_EVENT:// Vistas unicas
            return {
                ...state,
                numberOfUniquesViewsByEvent: payload.Data,
            };
        case GET_NUMBER_OF_GLOBAL_VIEWS_BY_EVENT:// Vistas globales
            return {
                ...state,
                numberOfGlobalViewsByEvent: payload.Data,
            };
        case GET_PHOTOS_BY_USER:
            return {
                ...state,
                photosByUser: payload,
            };
        case GET_ORDERS_AMOUNT:
            return {
                ...state,
                ordersAmount: payload.Data,
            };
        case GET_NUMBER_OF_ORDERS:
            return {
                ...state,
                numberOfOrders: payload.Data,
            };
        case GET_NUMBER_OF_PACK_ORDERS:
            return {
                ...state,
                numberOfPackOrders: payload.Data,
            };
        case GET_TOTAL_AMOUNT_ORDERS:
            return {
                ...state,
                totalAmountOrders: payload.Data,
            };
        case GET_TOTAL_AMOUNT_PACK_ORDERS:
            return {
                ...state,
                totalAmountPackOrders: payload.Data,
            };
        case GET_SOLD_PHOTOS:
            return {
                ...state,
                soldPhotos: payload.Data,
            };
        case GET_SOLD_PACKS_AMOUNT:
            return {
                ...state,
                soldPacksAmount: payload.Data,
            };
        case CLEAN_EVENT_STATS:
            return {
                ...state,
                numberOfPhotos: undefined,
                numberOfIndexedFaces: undefined,
                numberOfUsersAccessByCode: undefined,
                numberOfUsersWithMatch: undefined,
                numberOfDeliveredPhotos: undefined,
                numberOfSelfies: undefined,
                numberOfUniquesSharesByEvent: undefined,
                numberOfUniquesViewsByEvent: undefined,
                numberOfGlobalViewsByEvent: undefined,
                ordersAmount: undefined,
                numberOfOrders: undefined,
                numberOfPackOrders: undefined,
                totalAmountOrders: undefined,
                totalAmountPackOrders: undefined,
                soldPhotos: undefined,
                soldPacksAmount: undefined,
            };
        case LOADING_STATS:
            return {
                ...state,
                loading: payload
            };
        
        // ========================================
        // CASOS UNIFICADOS PARA COMPRAS
        // ========================================
        case GET_PURCHASES_FOR_HISTORY:
            return {
                ...state,
                purchasesData: payload,
            };
        case LOADING_PURCHASES_HISTORY:
            return {
                ...state,
                loadingPurchases: payload
            };
        
        // ========================================
        // CASOS UNIFICADOS PARA CONSUMOS
        // ========================================
        case GET_CONSUMPTIONS_FOR_HISTORY:
            return {
                ...state,
                consumptionsData: payload,
            };
        case LOADING_CONSUMPTIONS_HISTORY:
            return {
                ...state,
                loadingConsumptions: payload
            };

        case GET_CREDIT_MOVEMENTS:
            return {
                ...state,
                creditMovements: payload,
            };
        case LOADING_CREDIT_MOVEMENTS:
            return {
                ...state,
                loadingCreditMovements: payload
            };
        case SET_CREDIT_FILTERS:
            return {
                ...state,
                creditFilters: { ...state.creditFilters, ...payload }
            };
        case SIGN_OUT:
            return {
                ...state,
                creditFilters: initialState.creditFilters,
                purchasesData: undefined,
                consumptionsData: undefined,
                creditMovements: undefined
            };
        
        default:
            return state;
    }
};

export default statsReducer;